export default "__VITE_ASSET__CVDNcxDG__"